export const LIST_OF_ALL_USERS = 'LIST_OF_ALL_USERS'